import { useMemo } from "react";

import Tippy from "@tippyjs/react";

//Util
import { ICONES_MENSAGEM } from "@/frontend/utils/icones";

function TooltipItem(props) {
  const {
    position = "left",
    text,
    children,
    disabled = false,
    showImageHelp = false,
    showImageInfo = false,
    showImageAviso = false,
    showImageAtencao = false,
    className,
  } = props;

  const id = useMemo(
    () => (Math.random() + 1).toString(36).substring(2, 10),
    [],
  );

  const icon = children
    ? children
    : showImageHelp
      ? ICONES_MENSAGEM.AJUDA
      : showImageInfo
        ? ICONES_MENSAGEM.INFO
        : showImageAviso
          ? ICONES_MENSAGEM.AVISO
          : showImageAtencao
            ? ICONES_MENSAGEM.ATENCAO
            : null;

  const content = (
    <span
      id={`T${id}`}
      className={
        (showImageHelp || showImageInfo || showImageAviso || showImageAtencao
          ? "ms-1 me-1 "
          : "") + (className || "")
      }
    >
      {icon}
    </span>
  );

  if (disabled || !text) {
    return content;
  }

  return (
    <Tippy
      content={<span style={{ whiteSpace: "pre-line" }}>{text}</span>}
      placement={position}
      maxWidth={300}
      theme="light-border" //(default, light, material, etc)
      delay={[100, 50]} //[mostrar, esconder]
      arrow={true}
    >
      {content}
    </Tippy>
  );
}

export default TooltipItem;
